import { API } from "@/lib/api";

/**
 * Builds a questionnaire presign URL with token authentication.
 * Used for presigning URLs for questionnaire attachments.
 */
export const buildQuestionnairePresignUrl = (
  agreementId: string | undefined,
  token: string,
  action: "presign" | "complete" | "complete-delete" = "presign",
): string => {
  if (!agreementId) {
    return "";
  }
  return `${API.Agreements}/${agreementId}/questionnaire/attachments/${action}?token=${encodeURIComponent(token)}`;
};
